module.exports = __webpack_public_path__ + "img/25.a10ec357.jpg";